import { Flex } from '@mantine/core';
import { MilestoneLogo } from './MilestoneLogo';
import { MilestoneLogoSmall } from './MilestoneLogoSmall';
import { MilestonePhone } from './MilestonePhone';

type FireflyZigZagProps = {
  shouldFocus: boolean;
  isLgBreakpoint: boolean;
  isMdBreakpoint: boolean;
};

export default function FireflyZigZag({
  shouldFocus,
  isLgBreakpoint,
  isMdBreakpoint,
}: FireflyZigZagProps) {
  return (
    <Flex
      maw={595}
      miw={200}
      mih={isMdBreakpoint ? 350 : 250}
      direction="column"
      align="center"
      justify="center"
      style={{
        flex: 1,
      }}
    >
      {!shouldFocus ? (
        <div
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
          }}
        >
          {isLgBreakpoint ? (
            <MilestoneLogo
              style={{
                minWidth: '80vw',
                minHeight: '80vh',
                margin: '0 0 -5px 0',
              }}
            />
          ) : (
            <MilestoneLogoSmall
              style={{
                minWidth: '100vw',
              }}
            />
          )}
        </div>
      ) : (
        <MilestonePhone
          style={{
            width: isLgBreakpoint ? 'auto' : 200,
            height: isLgBreakpoint ? 'auto' : 200,
          }}
        />
      )}
    </Flex>
  );
}
